import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useThemeStore } from '@/stores/themeStore';
import { watchSystemTheme, applyTheme } from '@/lib/theme';
/**
 * Subscribes the document to the current theme store. Mounts the system-theme
 * watcher so `auto` mode tracks OS changes live, and re-applies the theme
 * class whenever the user picks a new mode.
 */
export function ThemeProvider({ children }) {
    const theme = useThemeStore((s) => s.theme);
    const setTheme = useThemeStore((s) => s.setTheme);
    useEffect(() => {
        applyTheme(theme);
    }, [theme]);
    useEffect(() => {
        return watchSystemTheme(() => {
            // Only trigger a re-apply when the user is in auto mode; the store
            // holds `auto` unchanged but applyTheme will resolve to the new system pref.
            if (useThemeStore.getState().theme === 'auto') {
                applyTheme('auto');
            }
        });
    }, [setTheme]);
    return _jsx(_Fragment, { children: children });
}
